<template>
  <v-app id="inspire" dark v-bind:class="{ 'drawer-is-open': drawer }">
    <error-modal :dialog="dialog" :error="dialogData" @close="dialog = false"></error-modal>
    <image-modal :src="currentImageModalSrc" @close="closeImageModal()"></image-modal>
    <v-navigation-drawer
      floating
      clipped
      temporary
      v-model="drawer"
      enable-resize-watcher
      app>
      <v-list dense>

        <v-list-tile v-if="usersMenu" @click="goTo('/users')">
          <v-list-tile-action>
            <v-icon></v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title class="subheading">
              Usuarios
            </v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>

        <v-list-tile v-if="tournamentsMenu" @click="goTo('/tournaments')">
          <v-list-tile-action>
            <v-icon></v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title class="subheading">
              Torneos
            </v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>

        <v-list-tile v-if="teamsMenu" @click="goTo('/teams')">
          <v-list-tile-action>
            <v-icon></v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title class="subheading">
              Equipos
            </v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>



        <v-list-tile v-if="fieldsMenu" @click="goTo('/fields')">
          <v-list-tile-action>
            <v-icon></v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title class="subheading">
              Canchas
            </v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>

        <v-list-tile v-if="complexesMenu" @click="goTo('/complexes')">
          <v-list-tile-action>
            <v-icon></v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title class="subheading">
              Complejos
            </v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>


        <v-list-tile v-if="notificationsMenu" @click="goTo('/notifications')">
          <v-list-tile-action>
            <v-icon></v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title class="subheading">
              Notificaciones
            </v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>

        <v-list-tile v-if="advertisingSpacesMenu" href="https://leagues.pitz.app/">
          <v-list-tile-action>
            <v-icon></v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title class="subheading">
              Espacios publicitarios
            </v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
        
        <v-list-tile v-if="sponsorshipsMenu" @click="goTo('/sponsorships')">
          <v-list-tile-action>
            <v-icon></v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title class="subheading">
              Patrocinios
            </v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>

        <v-list-tile @click="logOut">
          <v-list-tile-action>
            <v-icon></v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title class="subheading">Cerrar sesión</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>

      </v-list>
    </v-navigation-drawer>
    <v-toolbar color="green" app fixed clipped-left >
      <v-toolbar-side-icon @click.stop="drawer = !drawer" @click="clickMenuIcon()"></v-toolbar-side-icon>
      <v-toolbar-title>PITZ {{currentSession.sportPlaceName ? " | "+currentSession.sportPlaceName : ""}}</v-toolbar-title>
    </v-toolbar>
    <main>
      <v-content fluid>
        <router-view></router-view>
      </v-content>
    </main>
    <v-footer app fixed>
      <span>&copy; 2017</span>
    </v-footer>

  </v-app>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import Bus from '@/components/bus'

export default {
  name: "AppWrapper",
  data: () => ({
    drawer: false,
    usersMenu: false,
    teamsMenu: false,
    playersMenu: false,
    fieldsMenu: false,
    complexesMenu: false,
    tournamentsMenu: false,
    notificationsMenu: false,
    sponsorshipsMenu: false,
    advertisingSpacesMenu: false,
    dialog: false,
    dialogData: {
      code: 500,
      title: 'Server Error',
      message: 'Error'
    }
  }),
  props: {
    source: String
  },
  created() {
    //do something after creating vue instance
    Bus.$on(Bus.ACTION_SHOW_ALERT, event => {
      this.showDialog(event.title, event.msg)
    })
    this.checkSession()
    this.updateMenu()
  },
  computed: {
      ...mapGetters([
        'currentSession',
        'currentImageModalSrc',
        'isCalendarEdited'
      ])
    },
  methods: {
      ...mapActions([
        'checkSession',
        'logOut',
        'setImageModalSrc'
      ]),
      showDialog(title, msg){
        this.dialogData.title = title
        this.dialogData.message = msg
        this.dialog = true
      },
      showModal() {
        this.dialog = true
      },
      goTo(path) {
        this.$router.push({ path: path })
      },
      closeImageModal(){
        this.setImageModalSrc(null)
      },
      updateMenu(){

        switch (this.currentSession.type) {
          case "pitz":
            this.playersMenu = false
            this.usersMenu = true
            this.fieldsMenu = true
            this.teamsMenu = false
            this.complexesMenu = true
            this.tournamentsMenu = false
            this.notificationsMenu = true
            this.sponsorshipsMenu = true
            this.advertisingSpacesMenu = false
            break;
          case "place_admin":
            this.tournamentsMenu = true
            this.notificationsMenu = true
            this.playersMenu = true
            this.usersMenu = true
            this.fieldsMenu = true
            this.teamsMenu = true
            this.complexesMenu = false
            this.advertisingSpacesMenu = true
            break;
          default:

        }
      },
      clickMenuIcon() {
        if(this.$store.getters.isCalendarEdited){
          Bus.$emit(Bus.ACTION_SHOW_ALERT, { title: "Datos sin guardar", msg: "Para ir a otra pestaña necesita guardar o cancelar los cambios en el calendario" })
          this.drawer = false;
          return;
        }
      }
    }

}
</script>

<style lang="css">
.toolbar.toolbar--clipped {
  z-index: 10;
}

  div.overlay {
    /* override transition all on vuetifyjs */
    transition: opacity .5s cubic-bezier(.25,.8,.5,1);
  }
  .drawer-is-open .overlay.overlay--active {
    /* oerlayHeight = screen-height - toolbar-height */
    height: calc(100% - 64px);
    top: 64px;
  }
</style>



// WEBPACK FOOTER //
// src/components/pages/appWrapper.vue